import PropTypes from 'prop-types';
import clsx from 'clsx';
import Spinner from '@/components/Spinner';

const defaultProps = {
  submitting: false,
  disabled: true,
};

const propTypes = {
  label: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default function FormSubmit({
  label,
  submitting,
  disabled,
}) {
  return (
    <button
      className={clsx(
        'inline-flex items-center rounded-full space-x-2 leading-none px-5 py-3 focus:outline-none ring-4 ring-transparent',
        {
          'bg-gray-900 text-white shadow hover:bg-gray-800 focus:ring-gray-300 focus:bg-gray-900': submitting === false && disabled === false,
          'bg-gray-600 text-gray-300 pointer-events-none cursor-not-allowed': submitting === true || disabled === true,
        },
      )}
      type="submit"
      disabled={submitting || disabled}
    >
      <Spinner show={submitting} />
      <div className="font-semibold">
        {label}
      </div>
    </button>
  );
}

FormSubmit.defaultProps = defaultProps;
FormSubmit.propTypes = propTypes;
